import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, processIdentityParam, hasConsent } from "@/lib/visitor-tracking";

/**
 * Mounts once at the app root. Fires a pageview on every route change,
 * processes ?v=<contact_id>, and re-hooks after the visitor grants consent.
 */
export const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const fire = () => {
      processIdentityParam();
      trackPageview(location.pathname + location.search);
    };
    if (hasConsent()) {
      fire();
      return;
    }
    const onConsent = (e: Event) => {
      const detail = (e as CustomEvent).detail as { accepted?: boolean };
      if (detail?.accepted) fire();
    };
    window.addEventListener("noq5:consent", onConsent);
    return () => window.removeEventListener("noq5:consent", onConsent);
  }, [location.pathname, location.search]);

  return null;
};
